var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15751_32712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16797H5.83333V10.8346H7.5V9.16797ZM10.8333 9.16797H9.16667V10.8346H10.8333V9.16797ZM14.1667 9.16797H12.5V10.8346H14.1667V9.16797ZM15.8333 3.33464H15V1.66797H13.3333V3.33464H6.66667V1.66797H5V3.33464H4.16667C3.24167 3.33464 2.50833 4.08464 2.50833 5.0013L2.5 16.668C2.5 17.5846 3.24167 18.3346 4.16667 18.3346H15.8333C16.75 18.3346 17.5 17.5846 17.5 16.668V5.0013C17.5 4.08464 16.75 3.33464 15.8333 3.33464ZM15.8333 16.668H4.16667V7.5013H15.8333V16.668Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15751_32712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRangeIcon);
export default __webpack_public_path__ + "static/media/dateRangeIcon.8398097a615c2ee25839bc67aae28298.svg";
export { ForwardRef as ReactComponent };